export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const CREATE_USER_API_KEY = 'CREATE_USER_API_KEY'
export const FETCH_USER_INFO_REQUEST = 'FETCH_USER_INFO_REQUEST'
export const FETCH_USER_INFO_RESPONSE = 'FETCH_USER_INFO_RESPONSE'
export const LOAD_MANIFEST_INFO_REQUEST = 'LOAD_MANIFEST_INFO_REQUEST'
export const LOAD_MANIFEST_INFO_RESPONSE = 'LOAD_MANIFEST_INFO_RESPONSE'
export const LOAD_PROTECTED_PAGE_REQUEST = 'LOAD_PROTECTED_PAGE_REQUEST'
export const LOAD_PROTECTED_PAGE_RESPONSE = 'LOAD_PROTECTED_PAGE_RESPONSE'
export const RECEIVE_MOBILE_APPS = 'RECEIVE_MOBILE_APPS'
export const REQUEST_MOBILE_APPS = 'REQUEST_MOBILE_APPS'
export const RECEIVE_DEVELOPER_KEY_ERRORS = 'RECEIVE_DEVELOPER_KEY_ERRORS'
export const RECEIVE_QUANTIFIED_SITES = 'RECEIVE_QUANTIFIED_SITES'
export const REQUEST_QUANTIFIED_SITES = 'REQUEST_QUANTIFIED_SITES'
export const REQUEST_SITE_INFO = 'REQUEST_SITE_INFO'
export const RECEIVE_SITE_INFO = 'RECEIVE_SITE_INFO'
export const SUBMIT_FORCE_SCAN_REQUEST = 'SUBMIT_FORCE_SCAN_REQUEST'
export const SUBMIT_FORCE_SCAN_RESPONSE = 'SUBMIT_FORCE_SCAN_RESPONSE'



// WEBPACK FOOTER //
// ./src/constants/action-types.js